import { OrdersApiRemoteService } from '../../Services/api/orders/orders-service'
import { IBillProductOrderPayload, IOrdersListResponse } from '../../Services/api/orders/orders.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class BillProductOrderOrdersUseCase
implements IFormUsecase<IBillProductOrderPayload, IOrdersListResponse> {
  constructor (private readonly ServiceOrdersApi: OrdersApiRemoteService) {}
    

  public async handle (
    payload: IBillProductOrderPayload
  ): Promise<Result<IOrdersListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ServiceOrdersApi.bill(payload)

      if (response.isFailure) {
        return response
      }

      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
